import React from "react";
import RotationSchedulerPage from "./RotationSchedulerPage";

const WeekendCallSchedulePage = () => {
  return (
    <RotationSchedulerPage initialTab="weekend-call" singleTabMode={true} />
  );
};

export default WeekendCallSchedulePage;

